import { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';

import { Row } from 'components-antd';
import { Skeleton } from 'antd';
import { Card } from '../../Card';
import { priceConverter } from 'helpers';
import {
  getLoadingGraphsSelector,
  getFilteredGraphsSelector,
} from 'store/selectors/agentDashboard';
import { statPoint } from '../helper';

import styles from '../styles.module.scss';

export const ListedWidget = ({ teamStats }) => {
  const history = useHistory();
  const [totalRequests, setTotalRequests] = useState<number>(0);
  const [totalAmount, setTotalAmount] = useState<string>('0');

  const [currentStats, setCurrentStats] = useState<statPoint>();

  const { isPending } = useSelector(getLoadingGraphsSelector);
  const stats = useSelector(getFilteredGraphsSelector('listed', teamStats));
  useEffect(() => {
    !isPending && setCurrentStats(stats);
  }, [isPending, teamStats]);

  useEffect(() => {
    if (currentStats) {
      setTotalAmount(priceConverter(currentStats?.sum || 0, 2));
      setTotalRequests(currentStats?.count || 0);
    }
  }, [currentStats]);

  const redirectToWorkshop = () => {
    if (currentStats && totalRequests) {
      const Ids = currentStats.transactionIds;
      history.push(`/workshop/transactions?transactions=${Ids.map((Id) => `${Id}`)}`);
    }
  };

  return (
    <Card
      cardTitle={'Listed'}
      showHeader={false}
      cardWrapperClassName={classNames(styles.cardWrapper, styles.listings)}
      cardHeaderClassName={styles.cardHeader}
      cardBodyClassName={styles.cardBody}
    >
      <Fragment>
        <header className={styles.widgetHeader}>
          <h3
            className={classNames({ [styles.headerText]: totalRequests !== 0 })}
            onClick={redirectToWorkshop}
          >
            {'Listed'}
          </h3>
        </header>

        {isPending ? (
          <Skeleton.Input active size="large" className={styles.loaderSkeleton} />
        ) : (
          <Row
            className={classNames(styles.countContainer, {
              [styles.clickable]: totalRequests !== 0,
            })}
          >
            <span className={styles.totalAmount} onClick={redirectToWorkshop}>
              {totalAmount}
            </span>
            {+totalRequests !== 0 && (
              <span
                className={styles.count}
                onClick={redirectToWorkshop}
              >{`(${totalRequests})`}</span>
            )}
          </Row>
        )}
      </Fragment>
    </Card>
  );
};
